import { ShipmentGroupConfiguration, InternalShipmentGroup } from '../../models/shipment-group';
import { getShipmentGroupByCarrierAccountKey } from '../shipment-groups';
import { Dictionary } from '../../models/utils';

export function matchShipmentGroupConfiguration(
  shipmentGroupConfiguration: ShipmentGroupConfiguration,
  internalShipmentGroups: Dictionary<InternalShipmentGroup>,
  search: string | RegExp,
) {
  let matching = false;
  if (shipmentGroupConfiguration.name.search(search) >= 0) {
    matching = true;
  }
  for (const carrierAccountKey of shipmentGroupConfiguration.carrierAccountKeys) {
    const shipmentGroup = getShipmentGroupByCarrierAccountKey(internalShipmentGroups, carrierAccountKey);
    if (shipmentGroup && shipmentGroup.carrierAccountName.search(search) >= 0) {
      matching = true;
      break;
    }
  }
  return matching;
}
